module.exports = __webpack_public_path__ + "img/price-hen.45bc26a4.png";